<!--
 * @Author: your name
 * @Date: 2021-10-17 14:37:12
 * @LastEditTime: 2022-02-25 14:49:48
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \buyer_vue\src\App.vue
-->
<template>
  <div id="app" class="app-wrapper">
    <!-- 顶部广告 -->
    <!-- <top-ad v-if="this.$route.path==='/index'"></top-ad> -->
    <div v-if="this.$route.meta.screen === true" class="main-container">
      <router-view></router-view>
    </div>
    <template v-else>
      <!-- 头部 -->
      <x-header style="position: relative;z-index: 99999999;"></x-header>
      <div v-if="this.$route.meta.isKeepAlive === false" class="main-container">
        <router-view :key="$route.fullPath"></router-view>
      </div>
      <div v-else class="main-container">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </div>
      <!-- 底部 -->
      <x-footer></x-footer>
      <!-- <x-sidebar></x-sidebar> -->
    </template>
  </div>
</template>
<script>
import topAd from 'views/common/top-ad.vue';
import xHeader from 'views/common/layout/top-layout.vue';
import xFooter from 'views/common/layout/footer.vue';
import xSidebar from 'views/common/layout/sidebar.vue';
export default {
  data() {
    return {
      timmer: null
    }
  },
  components: {
    xHeader, xFooter, xSidebar, topAd
  },
  created() {
    this.init();
  },
  methods: {
    //设置半小时清空session
    init() {
      this.timmer = setTimeout(() => {
        this.$store.dispatch('LogOut', {}).then(() => {
          this.$store.dispatch('cleanCartLogOut');
          if (this.$route.path === '/index') {
            window.history.go(0);
          } else {
            this.$router.push({
              path: '/index'
            })
          }
        }).catch(err => {
          this.$Loading.error();
          this.$Message.error(err);
        });
      }, 30 * 60 * 1000);
    }
  }
}
</script>
<style lang="less">
@import "assets/css/index.less";
</style>
<style src="./assets/css/base.css"/>



// WEBPACK FOOTER //
// App.vue?05216f12